import { Component, Injectable } from '@angular/core';
import { CodeSnippet } from '../code-snippets/code-snippet.interface';



@Component({
    selector: 'read-adn-write-example',
    template: '',
    standalone: false
})
export class ReadAndWriteDatapointExample implements CodeSnippet{

    text: string = $localize`:@@script-editor.code-example.read-write-datapoints:Read/Write datapoints (classic)`

    category: string = 'examples';

    data: any;

    part = false;

    insert(): string | Promise<string> {
        return `function main()

    -- get value of int datapoint
    local int_value = getvalue("1!vLuaPointInt")
      
    -- calc the result
    local res = 2 + 3 * int_value
      
    -- set value of double datapoint by the trifold of int_value plus 2
    setvalue("1!vLuaPointDbl", res)
      
    -- set a value to the string datapoint
    setvalue("1!vLuaPointStr", "Calc: 2 + 3 * " .. int_value .. " = " .. res, true)
      
    -- output seperator
    show("VALUE: "..res)

end`
    }
}